<template>
    <div class="container-fluid p-0 highlighted-content-container d-none d-sm-none d-md-none d-lg-flex d-xl-flex">

        <div class="highlighted-content p-0" @mouseout="this.Hide()" @mouseover="this.SetActive('podcast')" @click="this.Redirect(`/podcast/${ this.podcast.slug }`)" :style="{ backgroundImage: `url('/storage/${this.podcast.thumbnail}')` }">
            <div class="highlighted-inner">
                <div v-show="this.Active == 'podcast'">
                    <h1 v-text="this.podcast.title"></h1>
                    <p v-text="this.podcast.description"></p>
                </div>
            </div>
            <div class="highlight-button-container">
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/podcast/${ this.podcast.slug }`"><i class="fas fa-headphones"></i> Latest Podcast</a>
                </button>
            </div>
        </div>

        <div v-if="this.event.id !== undefined" @mouseout="this.Hide()"  @mouseover="this.SetActive('event')" @click="this.Redirect(`/event/${ this.event.slug }`)" class="highlighted-content p-0" :style="{ backgroundImage: `url('/storage/${this.event.thumbnail}')` }">
            <div class="highlighted-inner">
                <div v-show="this.Active == 'event'">
                    <h1 v-text="this.event.name"></h1>
                    <p v-text="this.event.description"></p>
                </div>
            </div>
            <div class="highlight-button-container">
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/event/${ this.event.slug }`"><i class="fas fa-ticket-alt"></i> Sign up</a>
                </button>
            </div>
        </div>

        <div class="highlighted-content p-0" @mouseout="this.Hide()"  @mouseover="this.SetActive('blog')" @click="this.Redirect(`/blog/${ this.blog.slug }`)" :style="{ backgroundImage: `url('/storage/${this.blog.thumbnail}')` }">
            <div class="highlighted-inner">
                <div v-show="this.Active == 'blog'">
                    <h1 v-text="this.blog.title"></h1>
                    <p v-text="this.blog.description"></p>
                </div>
            </div>
            <div class="highlight-button-container">
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/blog/${ this.blog.slug }`"><i class="fas fa-book"></i> Latest Blog</a>
                </button>
            </div>
        </div>

    </div>

    <div class="container-fluid p-0 highlighted-content-container-mobile d-xs-flex d-sm-flex d-md-flex d-lg-none d-xl-none" style="flex-direction: column;">

        <hr class="divider">

        <div v-if="this.event.id !== undefined" class="latest-content-mobile flex-x center-x">
            <div class="image p-0" :style="{ backgroundImage: `url('/storage/${this.event.thumbnail}')` }"></div>
            <div class="text p-0">
                <h1 class="title clip-text-2" v-text="this.event.name"></h1>
                <p v-text="this.event.location"></p>
                <p v-text="this.Timestamp(this.event.start_date)"></p>
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/event/${ this.event.slug }`"><i class="fas fa-ticket-alt"></i> Sign up</a>
                </button>
            </div>
        </div>

        <hr class="divider">

        <div class="latest-content-mobile-alt flex-x center-x">
            <div class="image p-0" :style="{ backgroundImage: `url('/storage/${this.blog.thumbnail}')` }"></div>
            <div class="text p-0">
                <h1 class="title clip-text-2" v-text="this.blog.title"></h1>
                <p class="clip-text-3" v-text="this.blog.description"></p>
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/blog/${ this.blog.slug }`"><i class="fas fa-book"></i> Read</a>
                </button>
            </div>
        </div>

        <hr class="divider">

        <div class="latest-content-mobile flex-x center-x">
            <div class="image p-0" :style="{ backgroundImage: `url('/storage/${this.podcast.thumbnail}')` }"></div>
            <div class="text p-0">
                <h1 class="title clip-text-2" v-text="this.podcast.title"></h1>
                <p class="clip-text-3" v-text="this.podcast.description"></p>
                <button type="button" class="btn btn-warning highlight-button">
                    <a :href="`/podcast/${ this.podcast.slug }`"><i class="fas fa-headphones"></i> Listen</a>
                </button>
            </div>
        </div>

        <hr class="divider">

        <br>

    </div>

</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            Active: ""
        }
    },

    methods: {
        Timestamp ( date ) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },

        Redirect ( url ) {
            window.location = url;
        },

        SetActive ( section ) {
            this.Active = section;
        },

        Hide () {
            this.Active = "";
        }
    },

    props: ['blog', 'podcast', 'event'],

}
</script>